"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateUtils = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    (0, _classCallCheck2["default"])(this, DateUtils);
  }

  (0, _createClass2["default"])(DateUtils, null, [{
    key: "format",
    value: function format(date, mask) {
      if (!date) {
        return '-';
      }

      return (0, _moment["default"])(date).format(mask);
    }
  }, {
    key: "formatDuration",
    value: function formatDuration(seconds, mask, daysText) {
      if (seconds === undefined || seconds === null) {
        return '-';
      }

      var duration = _moment["default"].duration(seconds, 'seconds');

      var days = duration.days();
      return (days ? "".concat(days, " ").concat(daysText, " ") : '') + _moment["default"].utc().startOf('day').add(duration).format(mask);
    }
  }, {
    key: "localeChanged",
    value: function localeChanged() {
      var localData = _moment["default"].localeData();

      DateUtils.DATE_FORMAT = localData.longDateFormat('L');
      DateUtils.TIME_FORMAT = localData.longDateFormat('LT');
      DateUtils.TIME_FULL_FORMAT = localData.longDateFormat('LTS');
      DateUtils.DATE_TIME_FORMAT = "".concat(DateUtils.DATE_FORMAT, " ").concat(DateUtils.TIME_FORMAT);
      DateUtils.DATE_TIME_FULL_FORMAT = "".concat(DateUtils.DATE_FORMAT, " ").concat(DateUtils.TIME_FULL_FORMAT);
    }
  }]);
  return DateUtils;
}();

exports.DateUtils = DateUtils;
(0, _defineProperty2["default"])(DateUtils, "DATE_FORMAT", 'DD-MM-YYYY');
(0, _defineProperty2["default"])(DateUtils, "DATE_TIME_FORMAT", 'DD-MM-YYYY HH:mm');
(0, _defineProperty2["default"])(DateUtils, "DATE_TIME_FULL_FORMAT", 'DD-MM-YYYY HH:mm:ss');
(0, _defineProperty2["default"])(DateUtils, "TIME_FORMAT", 'HH:mm');
(0, _defineProperty2["default"])(DateUtils, "TIME_FULL_FORMAT", 'HH:mm:ss');